export const GET_TINITIAL = 'GET_TINITIAL'
export const SET_TINITIAL = 'SET_TINITIAL'
export const RECEIVED_TINITIAL = 'RECEIVED_TINITIAL'
export const GET_TFOLDER = 'GET_TFOLDER'
export const SET_TFOLDER = 'SET_TFOLDER'
export const RECEIVED_TFOLDER = 'RECEIVED_TFOLDER'
export const SET_CONTROLSIDEBAR_DISP = 'SET_CONTROLSIDEBAR_DISP'
export const SET_CONTROLSIDEBAR_DISP_FALSE = 'SET_CONTROLSIDEBAR_DISP_FALSE'
export const GET_CONTROLSIDEBAR_DISP = 'GET_CONTROLSIDEBAR_DISP'
export const GET_CURR_MODULE = 'GET_CURR_MODULE'
export const GET_CURR_CODAPP = 'GET_CURR_CODAPP'
export const SET_CURR_PATH = 'SET_CURR_PATH'
export const SET_MODULES = 'SET_MODULES'
export const GET_MODULES = 'GET_MODULES'
export const RECEIVED_MODULES = 'RECEIVED_MODULES'
export const SET_HEADER_ANNOUNCE_TOTAL = 'SET_HEADER_ANNOUNCE_TOTAL'
export const GET_HEADER_ANNOUNCE_TOTAL = 'GET_HEADER_ANNOUNCE_TOTAL'
export const SET_HEADER_ANNOUNCE_INFINITE_LOADING = 'SET_HEADER_ANNOUNCE_INFINITE_LOADING'
export const GET_HEADER_ANNOUNCE_INFINITE_LOADING = 'GET_HEADER_ANNOUNCE_INFINITE_LOADING'
export const RECEIVED_HEADER_ANNOUNCE_INFINITE_LOADING = 'RECEIVED_HEADER_ANNOUNCE_INFINITE_LOADING'
export const SET_HEADER_REQUEST_TOTAL = 'SET_HEADER_REQUEST_TOTAL'
export const GET_HEADER_REQUEST_TOTAL = 'GET_HEADER_REQUEST_TOTAL'
export const SET_HEADER_REQUEST_INFINITE_LOADING = 'SET_HEADER_REQUEST_INFINITE_LOADING'
export const GET_HEADER_REQUEST_INFINITE_LOADING = 'GET_HEADER_REQUEST_INFINITE_LOADING'
export const RECEIVED_HEADER_REQUEST_INFINITE_LOADING = 'RECEIVED_HEADER_REQUEST_INFINITE_LOADING'
export const SET_HEADER_APPROVE = 'SET_HEADER_APPROVE'
export const GET_HEADER_APPROVE = 'GET_HEADER_APPROVE'
export const RECEIVED_HEADER_NOTI_TOTAL = 'RECEIVED_HEADER_NOTI_TOTAL'

export const GET_CONTROLSIDEBAR_MAIL_LANG = 'GET_CONTROLSIDEBAR_MAIL_LANG'
export const SET_CONTROLSIDEBAR_MAIL_LANG = 'SET_CONTROLSIDEBAR_MAIL_LANG'
export const RECEIVED_CONTROLSIDEBAR_MAIL_LANG = 'RECEIVED_CONTROLSIDEBAR_MAIL_LANG'
export const POST_CONTROLSIDEBAR_MAIL_LANG = 'POST_CONTROLSIDEBAR_MAIL_LANG'



// WEBPACK FOOTER //
// ./src/store/modules/dash/mutation-types.js